import type {ReactElement} from 'react';
import React from 'react';
import type {SeasonalBrandkitPopoverProps} from './seasonal-brandkit-popover.types';
import {SeasonPopup} from '@Components/season-popup/season-popup';
import {isMobileScreenWidth} from '@Utils/dom.util';
import {PopoverDefaultAlignment} from '@Components/popover/popover.types';
import {getAssetUrl} from '@Utils/s3.util';
import {getImageFilenameForSeasonalBrandkitPopover, getTextForSeasonalBrandkitPopover} from '@Libraries/seasonal-brandkit-popover.library';
import {getCompatibleImageFileExtension} from '@Utils/image.util';
import {doesUserHaveSingleBrand} from '@Libraries/brands-library';
import type {Brands} from '@Components/editor-brands/editor-brands.types';
import {useAppSelector} from '@/hooks';
import {CURRENT_SEASON_NAME} from '@Libraries/seasons.library';

export function SeasonalBrandkitPopover({...props}: SeasonalBrandkitPopoverProps): ReactElement | null {
  const brands: Brands[] = useAppSelector((state) => {
    return state.brands.brands;
  });

  if (!CURRENT_SEASON_NAME) {
    return null;
  }

  return (
    <SeasonPopup
      onClose={() => {
        props.onMarkAsSeen();
      }}
      doCloseOnOuterClick={false}
      isPositionFixed
      referenceElement={props.referenceElement}
      arrowAlignment={isMobileScreenWidth() ? PopoverDefaultAlignment.BOTTOM_START : PopoverDefaultAlignment.RIGHT_START}
      imageUrl={getAssetUrl(`${getImageFilenameForSeasonalBrandkitPopover(CURRENT_SEASON_NAME)}.${getCompatibleImageFileExtension('webp')}`)}
      title={getTextForSeasonalBrandkitPopover(CURRENT_SEASON_NAME, doesUserHaveSingleBrand(brands))}
    />
  );
}
